import React, { useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import Spinner from '../../skills-experience/shared/spinner';
import { CdsFormModal } from 'clayco-component-library/lib';
import FormSchemas from '../../../utility/schemaLoader';
import ChangeType from '../../../shared/profileChangeEnum';
import AddressModalForm from './addressModalForm';

const AddressReview = ({data, apiProvider, reloadDetails, reloadChange, setReloadChange}) => {
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const schema = FormSchemas.addressReview;

    const record = data?.record;
    const pending = data?.pending;

    function handleEdit(){
        console.debug("I've altered the deal...");
        console.log("speg",data);
        setShowModal(true);
    }

function formatChangeRow(key) {
    const recordValueRaw = data?.record?.[key];
    const pendingValueRaw = data?.pending?.[key];
    const adminValueRaw = data?.admin?.[key];

    const recordValue = formatValue(recordValueRaw);
    const pendingValue = formatValue(pendingValueRaw);
    const adminValue = formatValue(adminValueRaw);

    const adminEqualsPending = adminValue === pendingValue;
    const adminEqualsRecord = adminValue === recordValue;

    const hasPendingKey = data?.pending?.hasOwnProperty(key);
    const isPendingDeletion = hasPendingKey && pendingValueRaw === "";
    const hasPendingChange = hasPendingKey && pendingValueRaw !== null;

    const isEmptyRecordValue =
        recordValue === null ||
        recordValue === undefined ||
        recordValue === "" ||
        recordValue === " " ||
        recordValue === 0;

    // 1. Admin matches record → just show record
    if (adminEqualsRecord && adminValue !== '' && adminValue !== undefined && adminValue !== null) {
        return <span>{recordValue}</span>;
    }

    // 2. Admin exists and differs from pending and record → show record + pending + admin
    if (hasPendingChange && (pendingValue !== '' && pendingValue !== undefined && pendingValue !== null)) {
        if (!adminEqualsPending && adminValue) {
            return (
                <>
                    <span className="cds-text-red cds-strikethrough">
                        {isEmptyRecordValue ? "N/A" : recordValue}
                    </span>
                    {!isPendingDeletion && (
                        <span className="ms-3 cds-strikethrough" style={{ opacity: 0.4 }}>
                            {pendingValue}
                        </span>
                    )}
                    <span className="ms-3">{adminValue}</span>
                </>
            );
        }

        // 3. Admin matches pending → show record + pending (unless deleted)
        return (
            <>
                <span className="cds-text-red cds-strikethrough">
                    {isEmptyRecordValue ? "N/A" : recordValue}
                </span>
                {!isPendingDeletion && <span className="ms-3">{pendingValue}</span>}
            </>
        );
    }

    // 4. No pending, but admin differs → show record + admin
    if (!adminEqualsRecord && adminValue) {
        return (
            <>
                <span className="cds-text-red cds-strikethrough">
                    {isEmptyRecordValue ? "N/A" : recordValue}
                </span>
                <span className="ms-3">{adminValue}</span>
            </>
        );
    }

    // 5. No pending or admin changes → just show record
    return <span>{recordValue}</span>;
}

    // Helper to format values safely
    function formatValue(value) {
        if (!value) return '';
        if (typeof value === 'object') {
            // Customize this to your structure
            return value.country || value.name || JSON.stringify(value);
        }
        return value;
    }

    async function saveChanges(formData){
        var values = formData;//schema.cast(formData);
        console.log("values", values);
        console.log("formdata", formData);
        values.state = data?.admin?.state;
        

        console.log("v",values)
        setLoading(true);
        values.employeeNumber = data.record.employeeNumber;
        var result = await apiProvider.Post("Profile/Admin/AddressEdit", values);

        if (result?.error !== undefined){
            // handle error
            setLoading(false);
        }else{
            // reload data
            await reloadDetails(ChangeType.AddressChange, data.record.employeeNumber);
            setReloadChange(!reloadChange);
            // stop loader // close modal
            setLoading(false);
            setShowModal(false);
        }
    }

    return(
        <>
        { loading ? 
            <Spinner show={loading}></Spinner>
        :
        <>
        <div className='name-review'>
        {/* <Row>
            <Col className='col col-12 mb-2'>
                <span className='cds-text-heavy'>Country</span>
            </Col>
            <Col className='col col-12 mb-3'>
                { formatChangeRow('country')}
            </Col>
        </Row> */}
        <Row>
            <Col className='col col-12 mb-2'>
                <span className="cds-text-heavy">Address Line 1</span>
            </Col>
            <Col className='col col-12 mb-3'>
                {formatChangeRow('addressLine1')}
            </Col>
        </Row>
        <Row>
            <Col className='col col-12 mb-2'>
                <span className='cds-text-heavy'>Address Line 2</span>
            </Col>
            <Col className='col col-12 mb-3'>
                {formatChangeRow('addressLine2')}
            </Col>
        </Row>
        <Row>
            <Col className='col col-12 mb-2'>
                <span className='cds-text-heavy'>City</span>
            </Col>
            <Col className='col col-12 mb-2'>
                {formatChangeRow('city')}
            </Col>
        </Row>
        <Row>
            <Col className='col col-12 mb-2'>
                <span className='cds-text-heavy'>State{/*/Region*/}</span>
            </Col>
            <Col className='col col-12 mb-2'>
                {formatChangeRow('state')}
            </Col>
        </Row>
        {/* <Row>
            <Col className='col col-12 mb-2'>
                <span className='cds-text-heavy'>State/Region</span>
            </Col>
            <Col className='col col-12 mb-2'>
                {formatChangeRow('region')}
            </Col>
        </Row> */}
        <Row>
            <Col className='col col-12 mb-2'>
                <span className='cds-text-heavy'>Postal Code</span>
            </Col>
            <Col className='col col-12 mb-2'>
                {formatChangeRow('postalCode')}
            </Col>
        </Row>
        <Row>
            <Col className='col col-12 mb-2'>
                <Button variant='primary' size='sm' aria-label='edit changes'
                    onClick={handleEdit}
                >
                    Edit
                </Button>
            </Col>
        </Row>
        </div>

        <CdsFormModal title={`Home Address Change , ${data?.record?.employeeNumber}`}
            schema={schema}
            onError={()=> alert('Something went wrong')}
            onSubmit={saveChanges}
            show={showModal}
            handleCloseClick={()=>{setShowModal(false)}}
        >
            <AddressModalForm model={data} />
        </CdsFormModal>
        </>
        }
        </>
    )
};

export default AddressReview;